import React, { FunctionComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IManufacturer } from 'interfaces';

interface IManufacturersListItemProps {
    manufacturer: IManufacturer;
}

export const ManufacturersListItem: FunctionComponent<IManufacturersListItemProps> = ({ manufacturer }) => {
    const { t, i18n } = useTranslation();

    const editDeviceURL = `/manufacturers/${manufacturer.id}`;

    // Each string goes in a div as well as a title, so precompute translations to avoid doing them twice.
    const t_is_deleted = t('manufacturersList.item.isDeleted');
    const t_isDeletedTitle = t_is_deleted + ' ' + manufacturer.is_deleted;

    return (
        <li className="manufacturersItem" data-cy="deviceItem_device">
            
            <div className="manufacturersItem_iconCol manufacturersItem_col">
                <div className="manufacturersItem_iconCircle">
                    <FontAwesomeIcon icon="hdd" className="manufacturersItem_icon" />
                </div>
            </div>
            <div className="manufacturersItem_detailsCol manufacturersItem_col">
                <div className="manufacturersItem_name ellipsis" title={manufacturer.name}>
                    {manufacturer.name}
                </div>
            </div>
            {manufacturer.is_deleted ? (
                <div className="manufacturersItem_detailsCol manufacturersItem_col">
                    <div className="manufacturersItem_detailsLeft manufacturersItem_col">
                        <div className="ellipsis" title={t_isDeletedTitle}>
                            {t_is_deleted}
                        </div>
                    </div>
                    <div className="manufacturersItem_detailsRight manufacturersItem_col">
                        <div className="ellipsis" title={t_isDeletedTitle}>
                            True
                        </div>
                    </div>
                </div>
            ) : (<>
                <div className="manufacturersItem_detailsCol manufacturersItem_col">
                    <div className="manufacturersItem_detailsLeft">
                    </div>
                </div></>)}
            <Link
                to={editDeviceURL}
                className="manufacturersItem_editCol"
                title={t('manufacturersList.item.editTooltip')}
                data-cy="deviceItem_editLink"
            >
                <FontAwesomeIcon icon={['far', 'edit']} className="manufacturersItem_editIcon" />
            </Link>
        </li>
    );
}